import React from 'react'
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { FormCard } from '@lmc/ui-kit'
import dayjs from 'dayjs'

type DisposalDetailContentProps = {
  record: any
  medicationName: string
}

export const DisposalDetailContent: React.FC<DisposalDetailContentProps> = ({
  record
}) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)

  const description = record?.description || record?.title || ''
  const previousExpectedStock =
    record?.previousExpectedStock || record?.amount2 || 0
  const disposedStock = record?.disposedStock || record?.amount1 || 0
  const expectedStock = record?.expectedStock || record?.amount2 || 0
  const stockUnit =
    record?.stockUnit || record?.stockQuantityType || t('TABLETS')

  const actionedBy = record?.actionedBy || record?.loggedBy
  const actionedByName = actionedBy
    ? `${actionedBy.name?.first || ''} ${actionedBy.name?.last || ''}`.trim()
    : ''
  const actionedDate = record?.actionedDate || record?.timeLogged
  const actionedDateFormatted = actionedDate
    ? dayjs(actionedDate).format('DD-MM-YYYY')
    : ''
  const disposalMethod = record?.disposalMethod || ''

  return (
    <FormCard level={2}>
      <InfoRow>
        <FullWidthSection>
          <StyledLabel level={2}>{t('DESCRIPTION')}</StyledLabel>
          <Text>{description || '-'}</Text>
        </FullWidthSection>
      </InfoRow>
      <InfoRow>
        <InfoSection>
          <StyledLabel level={2}>{t('PREVIOUS_EXPECTED_STOCK')}</StyledLabel>
          <Text weight="bold">
            {previousExpectedStock !== undefined
              ? `${previousExpectedStock} ${stockUnit}`
              : '-'}
          </Text>
        </InfoSection>
        <InfoSection>
          <StyledLabel level={2}>{t('DISPOSED_STOCK')}</StyledLabel>
          <Text weight="bold">
            {disposedStock !== undefined
              ? `${disposedStock} ${stockUnit}`
              : '-'}
          </Text>
        </InfoSection>
        <InfoSection>
          <StyledLabel level={2}>{t('EXPECTED_STOCK')}</StyledLabel>
          <Text weight="bold">
            {expectedStock !== undefined
              ? `${expectedStock} ${stockUnit}`
              : '-'}
          </Text>
        </InfoSection>
      </InfoRow>
      <InfoRow>
        <InfoSection>
          <StyledLabel level={2}>{t('ACTIONED_BY')}</StyledLabel>
          <Text weight="bold">{actionedByName || '-'}</Text>
        </InfoSection>
        <InfoSection>
          <StyledLabel level={2}>{t('ACTIONED_DATE')}</StyledLabel>
          <Text weight="bold">{actionedDateFormatted || '-'}</Text>
        </InfoSection>
        <InfoSection>
          <StyledLabel level={2}>{t('DISPOSAL_METHOD')}</StyledLabel>
          <Text weight="bold">{disposalMethod || '-'}</Text>
        </InfoSection>
      </InfoRow>
    </FormCard>
  )
}

const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 24px;
`

const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 185px;
`

const FullWidthSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const StyledLabel = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
`
